import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://97bda19ac94065ef9907743ca4fc8930@o4509379838279680.ingest.us.sentry.io/4509379839328256",
  sendDefaultPii: true,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <LanguageProvider> */}
      <App />
      {/* </LanguageProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);
